/*global $*/
/*eslint no-undef: "error"*/
export default class TabNumber {
    classButton = 'number--button'
    classHeader = 'page-header'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            let block = 'number-block-' + $(this).data('block')
            let heightHeader = $(`.${self.classHeader}`).height()
            console.log(heightHeader)

            if ($(`#${block}`).length > 0) {
                $('html,body').stop().animate(
                    {
                        scrollTop: $(`#${block}`).offset().top - heightHeader - 20
                    },
                    500
                )
            }
        })
    }
}
